var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWirelineSecondIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 692,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2l89.565 90H692",
    stroke: "#ED6725",
    strokeWidth: 5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2OTIiIGhlaWdodD0iOTUiIHZpZXdCb3g9IjAgMCA2OTIgOTUiIGZpbGw9Im5vbmUiPgogICAgPHBhdGggZD0iTTIgMkw5MS41NjQ5IDkySDY5MiIgc3Ryb2tlPSIjRUQ2NzI1IiBzdHJva2Utd2lkdGg9IjUiLz4KPC9zdmc+Cg==";
export { SvgWirelineSecondIconSvg as ReactComponent };